






























































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import StoreSuketKesanggupanDirujuk from "@/store/modules/SuketKesanggupanDirujuk";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import moment from "moment";
import pdf from "vue-pdf";

@Component({
  components: {
    BaseSuketCard,
    pdf
  }
})
export default class SuketKesanggupanDirujukTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  // Kartu ini hanya dirender pada halaman Suket IGD, sehingga pembatasan unit
  // sudah datang dari penempatannya. `["*"]` dipakai agar petugas IGD yang
  // unit login-nya berbeda tetap dapat mengisi; kunci read-only tetap datang
  // dari edit-window halaman.
  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.KesanggupanDirujuk);
  suketStore = StoreSuketKesanggupanDirujuk;

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  surat_date = moment().format("YYYY-MM-DD");
  creator_user_id = this.user.id;

  penyataan: any = {
    nama: null,
    tanggal_lahir: null,
    nik: null,
    alamat: null,
    hubungan: null
  };
  penjelasan: any = {
    tanggal: moment().format("YYYY-MM-DD"),
    jam: moment().format("HH:mm")
  };
  rujukan: any = { rs_tujuan: null, tindakan: null };
  saksi: any = { keluarga_nama: null, rs_nama: null };
  tempat_tanggal: any = { kota: "Bantul" };

  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  // Selaras dengan SuketKesanggupanDirujuk::HUBUNGAN_OPTIONS (server).
  hubunganOptions = [
    { text: "Diri saya sendiri (pasien)", value: "diri_sendiri" },
    { text: "Suami", value: "suami" },
    { text: "Istri", value: "istri" },
    { text: "Anak", value: "anak" },
    { text: "Ayah", value: "ayah" },
    { text: "Ibu", value: "ibu" },
    { text: "Saudara Kandung", value: "saudara_kandung" }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  /**
   * Hari hanya pratinjau — nilai final selalu dihitung ulang server-side
   * (SuketKesanggupanDirujuk::recomputeHari) agar tidak bisa berkonflik
   * dengan tanggal yang tersimpan.
   */
  get hariText() {
    const tgl = this.penjelasan.tanggal;
    if (!tgl) return "-";

    const tanggal = moment(tgl, "YYYY-MM-DD");
    if (!tanggal.isValid()) return "-";

    const namaHari = [
      "Minggu",
      "Senin",
      "Selasa",
      "Rabu",
      "Kamis",
      "Jumat",
      "Sabtu"
    ];

    return namaHari[tanggal.day()];
  }

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(
          EnSuketCategory.KesanggupanDirujuk,
          this.dataSuket.id
        )
      : null;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        penyataan: this.penyataan,
        penjelasan: this.penjelasan,
        rujukan: this.rujukan,
        saksi: this.saksi,
        tempat_tanggal: this.tempat_tanggal
      },
      surat_date: this.surat_date,
      creator_user_id: this.creator_user_id
    };
  }

  mounted() {
    this.hydrate(this.dataSuket);
  }

  hydrate(d: any) {
    this.register_id = d?.register_id || this.register;
    this.pasien_rm = d?.pasien_rm || this.pasien.rm;
    this.unit_id = d?.unit_id || this.user.unit_id;
    this.surat_date = d?.surat_date
      ? moment(d.surat_date).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    this.creator_user_id = d?.creator_user_id || this.user.id;

    const c = d?.content;
    if (c) {
      // Spread agar key baru tetap ter-default pada record lama.
      this.penyataan = { ...this.penyataan, ...(c.penyataan || {}) };
      this.penjelasan = { ...this.penjelasan, ...(c.penjelasan || {}) };
      this.rujukan = { ...this.rujukan, ...(c.rujukan || {}) };
      this.saksi = { ...this.saksi, ...(c.saksi || {}) };
      this.tempat_tanggal = {
        ...this.tempat_tanggal,
        ...(c.tempat_tanggal || {})
      };
    }
  }

  /**
   * Bila yang menyatakan adalah pasien sendiri, identitasnya sudah pasti sama
   * dengan master pasien — diisikan otomatis agar tidak diketik ulang. Isian
   * tetap dapat disunting (mis. NIK pada master belum lengkap).
   */
  onChangeHubungan(val: string) {
    if (val !== "diri_sendiri") return;

    this.penyataan.nama = this.pasien.nama || this.penyataan.nama;
    this.penyataan.nik = this.pasien.nik || this.penyataan.nik;
    this.penyataan.alamat = this.pasien.alamat || this.penyataan.alamat;
    this.penyataan.tanggal_lahir = this.pasien.tgl_lahir
      ? moment(this.pasien.tgl_lahir).format("YYYY-MM-DD")
      : this.penyataan.tanggal_lahir;
  }

  @Watch("dataSuket")
  changeDataSuket(val: any) {
    this.hydrate(val);
  }

  save() {
    if (this.saving) return;

    const wajib = [
      [this.penyataan.hubungan, "Hubungan dengan pasien"],
      [this.penyataan.nama, "Nama yang menyatakan"],
      [this.penyataan.tanggal_lahir, "Tanggal lahir yang menyatakan"],
      [this.penyataan.nik, "NIK/No. KTP"],
      [this.penyataan.alamat, "Alamat yang menyatakan"],
      [this.penjelasan.tanggal, "Tanggal pemberian penjelasan"],
      [this.penjelasan.jam, "Jam pemberian penjelasan"],
      [this.rujukan.rs_tujuan, "Rumah sakit tujuan rujukan"],
      [this.rujukan.tindakan, "Tindakan yang disetujui"],
      [this.saksi.keluarga_nama, "Nama saksi keluarga"],
      [this.saksi.rs_nama, "Nama saksi RS"]
    ];

    const kosong = wajib.filter(item => !item[0]).map(item => item[1]);
    if (kosong.length) {
      appModule.sendErrorAlert(`Kolom wajib belum diisi: ${kosong.join(", ")}`);
      return;
    }

    if (
      moment(this.penyataan.tanggal_lahir, "YYYY-MM-DD").isAfter(moment(), "day")
    ) {
      appModule.sendErrorAlert(
        "Tanggal lahir yang menyatakan tidak boleh di masa depan"
      );
      return;
    }

    if (
      moment(this.penjelasan.tanggal, "YYYY-MM-DD").isAfter(moment(), "day")
    ) {
      appModule.sendErrorAlert(
        "Tanggal pemberian penjelasan tidak boleh di masa depan"
      );
      return;
    }

    this.saving = true;
    const action = this.dataSuket
      ? this.suketSvc.update(this.dataSuket.id, this.input)
      : this.suketSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        StoreSuketKesanggupanDirujuk.getSuketByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }
}
